import { render } from 'preact';
import './style/index.css';
import App from './components/app';

const container = document.getElementById('app');
if (container) {
  render(<App />, container);
}
